import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ZoneImportModel } from 'src/app/models/imports/zone-import-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { ZoneModel } from './../../models/archive/zone.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  constructor(private _httpClient: HttpClient) { }

  createZone(zoneContractModel: ZoneModel): Observable<ZoneModel> {
    return this._httpClient.post<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.CreateZone}`,
      zoneContractModel);
  }

  deleteZone(zoneId: number): Observable<ZoneModel> {
    return this._httpClient.delete<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.DeleteZone}/${zoneId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.zone.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllSellersForSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetAllSellersForSelect}`,
      { params: params });
  }

  getAllZonesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetAllZonesForSelectAsync}`,);
  }

  getAllZonesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetAllZonesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getZoneById(zoneId: number): Observable<ZoneModel> {
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetByIdAsync}/${zoneId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstZoneByKeysAsync(branchId: number): Observable<ZoneModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetFirstZoneByKeysAsync}`,
      { params: params }
    );
  }

  getLastZoneByKeysAsync(branchId: number): Observable<ZoneModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetLastZoneByKeysAsync}`,
      { params: params }
    );
  }

  getNextZoneByKeysAsync(branchId: number, code: number): Observable<ZoneModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetNextZoneByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusZoneByKeysAsync(branchId: number, code: number): Observable<ZoneModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetPreviusZoneByKeysAsync}`,
      { params: params }
    );
  }

  GetZoneByBranchId(branchId: number): Observable<Array<ZoneModel>> {
    return this._httpClient.get<Array<ZoneModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetZoneByBranchId}/${branchId}`)
  }

  getZoneByCode(branchId: number, code: number): Observable<ZoneModel> {
    return this._httpClient.get<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.GetZoneByCode}/${branchId}/${code}`);
  }

  importZones(zoneImports: Array<ZoneImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.ImportZones}`, zoneImports
    );
  }

  updateZone(zoneContractModel: ZoneModel): Observable<ZoneModel> {
    return this._httpClient.put<ZoneModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.zone.UpdateAsync}`,
      zoneContractModel);
  }
}
